import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/footer.css";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaCamera,
  FaVideo,
  FaHeart,
  
  
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* About */}
        <div className="footer-box">

          <h2>The StoryLine Studios</h2>

          <p>
            Capturing unforgettable memories with creativity,
            passion and cinematic excellence. We specialize in
            premium wedding photography, cinematic videography,
            pre-wedding shoots, maternity, birthdays and all
            special events.
          </p>

          <div className="footer-highlights">

            <div className="highlight-item">
              <FaCamera />
              <span>500+ Happy Clients</span>
            </div>

            <div className="highlight-item">
              <FaVideo />
              <span>Professional Cinematic Films</span>
            </div>

            <div className="highlight-item">
              <FaHeart />
              <span>Making Memories Forever</span>
            </div>

          </div>

          <Link to="/admin/contactpage" className="footer-book-btn">
  Book Your Shoot
</Link>

        </div>

        {/* Quick Links */}

        

        {/* Services */}

        
     

        {/* Contact */}

        <div className="footer-box">

          <h3>Contact</h3>

          <div className="footer-contact">

            <p>
              <FaMapMarkerAlt />
              Khammam, Telangana
            </p>

           <p>
  <FaPhoneAlt />
  <a href="tel:+919000306722" className="footer-contact-link">
    +91 90003 06722
  </a>
</p>

          <p>
  <FaEnvelope />
  <a
    href="mailto:thestorylinestudioss@gmail.com"
    className="footer-contact-link"
  >
    thestorylinestudioss@gmail.com
  </a>
</p>

          </div>

          <div className="footer-hours">

            <h4>
              <FaClock />
              Working Hours
            </h4>

            <p>Monday - Sunday</p>

            <p>09:00 AM - 09:00 PM</p>

            <p>Available for Outdoor Shoots</p>

          </div>

          <div className="social-icons">

            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://youtube.com"
              target="_blank"
              rel="noreferrer"
            >
              <FaYoutube />
            </a>

            <a
              href="https://wa.me/919000306722"
              target="_blank"
              rel="noreferrer"
            >
              <FaWhatsapp />
            </a>

          </div>

        </div>

      </div>

      <div className="copyright">

        © {new Date().getFullYear()} StoryLine Studios. All Rights Reserved.

      </div>

    </footer>
  );
};

export default Footer;